import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import '../../../resources/css/relatorio.css';

class ApostilasPorNucleo extends React.Component {

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.RELATORIO_APOSTILAS_POR_NUCLEO)
            return null;

        const token = this.props.token;

        const datatablesColumns = [
            { data: "nucleo", title: "Núcleo", render: $.datatable.renders.text() },
            { data: "apostila", title: "Apostila", render: $.datatable.renders.text() },
            { data: "count", title: "Enviadas", render: $.datatable.renders.number(".", ",", 0) },
            { data: "vinculadas", title: "Associadas", render: $.datatable.renders.number(".", ",", 0) },
            { data: "estoque", title: "Estoque", render: $.datatable.renders.number(".", ",", 0) },
        ];

        let urlBase = '/api/reports/apostilas';
        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: urlBase,
        });

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'ApostilasPorNucleo',
            },
        ];

        const domClassName = 'report-apostilas-por-nucleo-datatables';

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Relatório de Apostilas por núcleo</h2>
                    </div>
                </div>

                <Datatable DomClassName={domClassName}
                           title={null}
                           subTitle={null}
                           responsive={true}
                           pageLength={100}
                           buttons={buttons}
                           editorCreateVisible={false}
                           editorEditVisible={false}
                           editorRemoveVisible={false}
                           datatablesColumns={datatablesColumns}
                           datatablesSelect={callbacks.select.bind(callbacks)}
                />
            </div>
        );
    }
}

export default ApostilasPorNucleo;



// WEBPACK FOOTER //
// src/views/pages/RelatorioApostilasPorNucleo.jsx